

































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { isArray, sortBy } from 'lodash';
import { AgGridVue } from '@ag-grid-community/vue';
import {
  GridReadyEvent,
  ICellRendererParams,
  IServerSideDatasource,
  IServerSideGetRowsParams,
  SelectionChangedEvent,
  ValueFormatterParams,
  ValueGetterParams,
} from '@ag-grid-community/core';
import { plainToClass } from 'class-transformer';
import CrmAppBar from '@/components/crm/app-bar.vue';
import { InjectionIdEnum } from '@/enums/injection-id.enum';
import { UserTypeEnum } from '@/enums/crm/user-type.enum';
import DataGridFilter from '@/components/data-grid-filter.vue';
import DateRangeFilter from '@/components/date-range-filter.vue';
import dayjs from '@/plugins/dayjs';
import SettingsService from '@/services/crm/settings.service';
import ContactService from '@/services/crm/contact.service';
import SettingsModel from '@/models/crm/settings.model';
import UserContactInfo from '@/models/crm/user-contact-info.model';
import ActivityService from '@/services/crm/activity.service';
import UserModel from '@/models/user.model';
import { IDateRangeConfig } from '@/interfaces/date-range-config.interface';
import { DateHelper } from '@/utils/helpers/date-helper';
import Tooltip from '@/components/tooltip.vue';
import HistoryTypeModel from '@/models/crm/history-type.model';
import AgGridWrapper from '@/components/ag-grid-wrapper.vue';
import { IGridConfig } from '@/interfaces/grid-config.interface';
import { GridHelper } from '@/utils/helpers/grid-helper';
import ContentDialog from '@/components/content-dialog.vue';
import { IDialogConfig } from '@/interfaces/dialog-config.interface';
import { IKeyValue } from '@/interfaces/key-value.interface';
import { IGridCellEvent } from '@/interfaces/grid-cell-clicked.interface';
import CallCenterCallModel from '@/models/crm/call-center-call.model';
import { CallCenterCallTypeEnum } from '@/enums/crm/call-center-call-type.enum';
import { ConversationTypeEnum } from '@/enums/crm/conversation-type.enum';
import GroupModel from '@/models/crm/group.model';
import CallCenterCallService from '@/services/crm/call-center-call.service';
import { CallCenterCallStatusEnum } from '@/enums/crm/call-center-call-status.enum';
import CrmCallCenterHistoryCall from '@/components/crm/call-center-history-call.vue';

type DataGridFilterConfig = {
  period: (Date | undefined)[];
  callType: CallCenterCallTypeEnum[] | null;
  resultType: CallCenterCallTypeEnum[] | null;
  codClient: string | null;
  attendant: number[] | null;
  contactType: ConversationTypeEnum[] | null;
  protocol: number | null;
  contactName: string | null;
  legalName: string | null;
  contactNumber: string | null;
  group: GroupModel[] | null;
  historyType: HistoryTypeModel[] | null;
};

interface ISelectOption<T> {
  code: T;
  description: string;
}

@Component({
  components: {
    DataGridFilter,
    DateRangeFilter,
    CrmAppBar,
    AgGridWrapper,
    AgGridVue,
    Tooltip,
    ContentDialog,
    CrmCallCenterHistoryCall,
  },
})
export default class CrmCallReport extends Vue {
  @inject(InjectionIdEnum.CrmSettingsService)
  private settingsService!: SettingsService;

  @inject(InjectionIdEnum.CrmContactService)
  private contactService!: ContactService;

  @inject(InjectionIdEnum.CrmActivityService)
  private activityService!: ActivityService;

  @inject(InjectionIdEnum.CallCenterCallService)
  private callCenterCallService!: CallCenterCallService;

  settings: SettingsModel | null = null;

  userContactInfo: UserContactInfo | null = null;

  dialogConfig: IKeyValue<IDialogConfig> = {
    history: {
      show: false,
      call: null,
    },
    export: {
      show: false,
      exportAll: false,
      exportCurrent: true,
    },
  };

  // #region Grid

  grid: GridReadyEvent | null = null;

  gridClient: GridReadyEvent | null = null;

  gridSettings: IGridConfig = {
    loading: false,
    itemsPerPage: 30,
    columnDefs: [
      GridHelper.getSelectionColDef({ headerCheckboxSelection: false }),
      {
        headerName: `${this.$t('crm.view.callReport.grid.startDate')}`,
        colId: 'startDate',
        field: 'dataAtendimento',
        maxWidth: 155,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataAtendimento || params.data.dataInclusao;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.endDate')}`,
        colId: 'endDate',
        field: 'dataFinalizacao',
        maxWidth: 155,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const date = params.data.dataFinalizacao;
          return DateHelper.formatToIsoDateTimeString(date);
        },
        valueFormatter: (params: ValueFormatterParams): string => {
          if (params.value && params.value !== 'Invalid Date') {
            return DateHelper.formatToLocale(params.value, 'dateTime');
          }
          return '';
        },
        cellClass: 'dateISO',
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.callType')}`,
        colId: 'callType',
        field: 'tipoLigacao',
        maxWidth: 155,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            const callType = params.data.tipoLigacao || '';

            return this.$t(`crm.view.callReport.filter.${callType.toLowerCase()}`).toString();
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.resultType')}`,
        colId: 'resultType',
        field: 'statusConclusao',
        maxWidth: 155,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const resultType = params.data.statusConclusao || '';
          if (resultType) {
            return this.$t(`crm.view.callReport.filter.result_${resultType.toLowerCase()}`).toString();
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.contactType')}`,
        colId: 'contactType',
        field: 'tipo',
        maxWidth: 155,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const contactType = params.data.tipo || '';
          if (contactType) {
            return this.$t(`crm.view.callReport.filter.${contactType.toLowerCase()}`).toString();
          }

          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.protocol')}`,
        colId: 'protocol',
        field: 'protocolo',
        cellClass: 'cell-grid-link',
        maxWidth: 150,
        sortable: true,
        cellStyle: (params: any): any => {
          let color = '';
          if ([CallCenterCallStatusEnum.NewCall, CallCenterCallStatusEnum.Finish].includes(params.data.statusLigacao)) {
            color = '#1CB2A4';
          }

          if ([CallCenterCallStatusEnum.Transfer].includes(params.data.statusLigacao)) {
            color = '#FF9800';
          }

          return {
            color,
          };
        },
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.attendant')}`,
        colId: 'attendant',
        field: 'atendente.nome',
        flex: 0.5,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.contactNumber')}`,
        colId: 'contactNumber',
        field: 'numeroContato',
        flex: 0.5,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.legalName')}`,
        colId: 'legalName',
        sortable: false,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            if (params.data.tipo === 'CLIENT') {
              return params.data?.cliente?.nome || params.data?.cliente?.nomeFantasia;
            }
            if (params.data.tipo === 'PROSPECT') {
              return (
                params.data?.prospect?.razaoSocial
                || params.data?.prospect?.nome
                || params.data?.cliente?.nome
                || params.data?.cliente?.nomeFantasia
              );
            }
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.contactName')}`,
        colId: 'contactName',
        field: 'contato.nome',
        flex: 0.8,
        sortable: true,
        valueGetter: (params: ValueGetterParams): string => {
          const isRowPinned = params.node && params.node.rowPinned;
          if (!isRowPinned) {
            return params.data?.contato?.nome || params.data.numeroWhatsapp;
          }
          return '';
        },
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.group')}`,
        colId: 'group',
        field: 'grupoArea.descricao',
        flex: 0.8,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.historyType')}`,
        colId: 'historyType',
        field: 'tipoHistorico.nome',
        flex: 0.8,
        sortable: true,
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.description')}`,
        colId: 'description',
        field: 'descricao',
        maxWidth: 150,
        sortable: true,
        cellRenderer: (params: ICellRendererParams): string => params.data.descricao,
      },
      {
        headerName: `${this.$t('crm.view.callReport.grid.recordingUrl')}`,
        colId: 'recordingUrl',
        field: 'urlGravacaoChamada',
        flex: 0.4,
        sortable: true,
        // eslint-disable-next-line arrow-body-style
        cellRenderer: (params: ICellRendererParams): string => {
          // eslint-disable-next-line max-len
          return `<a href="${params.data.urlGravacaoChamada}" target="_blank"><span  class="v-icon  mdi mdi-microphone-outline"></span></a>`;
        },
      },
    ],
  };

  serverSideDatasource: IServerSideDatasource = {
    getRows: this.getRows,
  };

  items: CallCenterCallModel[] = [];

  itemsClient: CallCenterCallModel[] = [];

  selected: CallCenterCallModel[] = [];

  // #endregion

  // #region filters

  filterOpen = 1;

  multipleFilterChanged = false;

  predefinedPeriodRanges: IDateRangeConfig[] = this.getDateRanges();

  filters: DataGridFilterConfig = {
    period: [
      dayjs()
        .startOf('month')
        .toDate(),
      dayjs().toDate(),
    ],
    callType: [CallCenterCallTypeEnum.Active, CallCenterCallTypeEnum.Receptive],
    resultType: [CallCenterCallTypeEnum.Active, CallCenterCallTypeEnum.NotSuccessful],
    contactType: [ConversationTypeEnum.Client, ConversationTypeEnum.Prospect, ConversationTypeEnum.Undefined],
    codClient: null,
    attendant: null,
    protocol: null,
    legalName: null,
    contactName: null,
    contactNumber: null,
    group: null,
    historyType: null,
  };

  totalRows = 0;

  isExporting = false;

  callTypeOptions: ISelectOption<CallCenterCallTypeEnum>[] = [];

  resultTypeOptions: ISelectOption<CallCenterCallTypeEnum>[] = [];

  contactTypeOptions: ISelectOption<ConversationTypeEnum>[] = [];

  attendantOptions: UserModel[] = [];

  historyTypeOptions: HistoryTypeModel[] = [];

  groupOptions: GroupModel[] = [];

  // #endregion

  async mounted(): Promise<void> {
    const loader = this.$loading.show();
    try {
      await this.loadFilterOptions();
      this.settings = await this.settingsService.getSettings();
      this.userContactInfo = await this.contactService.getLoggedUserContactInfo();
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    } finally {
      loader.hide();
    }
  }

  private async getRows(params: IServerSideGetRowsParams) {
    const sortMapping = {
      startDate: 'l.dataatendimento',
      endDate: 'l.datafinalizacao',
      callType: 'l.tipoligacao',
      resultType: 'l.statusconclusao',
      contactType: 'l.tipo',
      protocol: 'l.protocolo',
      contactNumber: 'l.numeroContato',
      description: 'l.descricao',
      group: 'cga.descricao',
      attendant: 'au.nome',
      contactName: 'cc.nome',
      historyType: 'cth.nome',
    };

    const page = this.isExporting ? 1 : (params.request.endRow || 1) / (this.gridSettings.itemsPerPage || 1);
    let orderBy: string | undefined;

    if (params.request.sortModel?.length) {
      const mappedSort = params.request.sortModel.map((x) => `${sortMapping[x.colId]} ${x.sort}`);

      orderBy = mappedSort.join(', ');
    }

    try {
      this.filters.period[0] = dayjs(this.filters.period[0])
        .startOf('day')
        .toDate();
      this.filters.period[1] = dayjs(this.filters.period[1])
        .endOf('day')
        .toDate();
      if (this.settings === null) this.settings = await this.settingsService.getSettings();
      if (this.userContactInfo === null) this.userContactInfo = await this.contactService.getLoggedUserContactInfo();

      // Removido para exibir todas as ligações
      // if (this.userContactInfo !== null && !this.notNormalUser) {
      //   this.filters.attendant = [this.userContactInfo.id];
      // }

      const response = await this.callCenterCallService.queryCalls(
        page,
        this.isExporting ? -1 : this.gridSettings.itemsPerPage || 1,
        this.filters as unknown,
        orderBy,
      );

      this.totalRows = response.total;

      params.success({
        rowData: response.results,
        rowCount: response.total,
      });

      if (this.isExporting && this.gridClient) {
        const onlySelected = false;
        this.gridClient.api.setRowData(response.results);
        this.gridClient.api.exportDataAsExcel({
          onlySelected,
          allColumns: true,
          author: 'Geovendas',
          sheetName: 'Ligações',
          fileName: CallCenterCallService.generateCallReportExportFilename(new Date()),
        });
      }
      this.gridClient?.api.setRowData([]);
      this.isExporting = false;
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
      params.fail();
    }
  }

  onFilterChange(type: string): void {
    if (type === 'multiple' && !this.multipleFilterChanged) {
      return;
    }

    this.applyFilter();
  }

  async applyFilter(): Promise<void> {
    this.multipleFilterChanged = false;

    try {
      if (this.grid?.api) {
        this.grid.api.deselectAll();
        this.selected = [];

        this.grid.api.paginationGoToFirstPage();
        this.grid.api.refreshServerSideStore({});
      }
    } catch (err) {
      this.$notify.error(err && (err as Error).message);
    }
  }

  onSelectionChanged(change: SelectionChangedEvent, selected: CallCenterCallModel[]): void {
    this.selected = selected;
  }

  onExport(): void {
    this.dialogConfig.export.show = true;
  }

  onExportConfirm(selected: CallCenterCallModel[]): void {
    if (this.grid) {
      if (this.dialogConfig.export.exportAll) {
        this.isExporting = true;
        const loader = this.$loading.show();
        try {
          this.grid.api.purgeServerSideCache();
        } catch (err) {
          this.$notify.error(err && (err as Error).message);
        } finally {
          loader.hide();
        }
      } else {
        const onlySelected = !!selected.length && this.items.length !== selected.length;
        const columnKeys = this.gridSettings.columnDefs
          .filter((x) => !x.checkboxSelection)
          .map((x) => x.colId || x.field || '');
        this.grid.api.exportDataAsExcel({
          onlySelected,
          columnKeys,
          allColumns: true,
          author: 'Geovendas',
          sheetName: 'Ligações',
          fileName: CallCenterCallService.generateCallReportExportFilename(new Date()),
        });
      }
    }
    this.dialogConfig.export.show = false;
  }

  onExportAllChange(): void {
    if (this.dialogConfig.export.exportAll) {
      this.dialogConfig.export.exportCurrent = false;
    }
  }

  onExportCurrentChange(): void {
    if (this.dialogConfig.export.exportCurrent) {
      this.dialogConfig.export.exportAll = false;
    }
  }

  async onCellClick(event: IGridCellEvent<CallCenterCallModel>): Promise<void> {
    if (!event.data || event?.colDef?.colId !== 'protocol') {
      return;
    }

    this.openHistoryCallDialog(plainToClass(CallCenterCallModel, event.data));
  }

  openHistoryCallDialog(call: CallCenterCallModel): void {
    if (!call) {
      return;
    }

    this.dialogConfig.history.show = true;
    this.dialogConfig.history.call = call;
  }

  onCloseHistoryDialogClose(): void {
    this.dialogConfig.history.show = false;
    this.dialogConfig.history.call = false;
  }

  onCloseExportDialogClose(): void {
    this.dialogConfig.export.show = false;
    this.dialogConfig.export.exportAll = false;
    this.dialogConfig.export.exportCurrent = true;
  }

  get activeFilters(): number {
    let active = 0;
    const filtersToIgnore = ['periodType'];
    const filterKeys = Object.keys(this.filters);

    if (this.userContactInfo !== null && !this.notNormalUser) {
      filtersToIgnore.push('attendant');
    }

    filterKeys.forEach((key) => {
      const filter = this.filters[key];
      if (key === 'period') {
        const validDates = filter.filter((date) => date && !Number.isNaN(new Date(date).getTime()));
        if (validDates.length === 0) {
          return;
        }
      }
      switch (key) {
        default:
          if (!filtersToIgnore.includes(key) && filter && !(isArray(filter) && !filter.length)) {
            active += 1;
          }
      }
    });

    return active;
  }

  get historyDialogTitle(): string {
    const protocol = (this.dialogConfig.history.call as CallCenterCallModel)?.protocolo;
    return this.$t('crm.view.callReport.dialog.history.title', { protocol }).toString();
  }

  get exportDialogTitle(): string {
    return this.$t('crm.view.callReport.dialog.export.title').toString();
  }

  get notNormalUser(): boolean {
    return this.settings?.loggedUserType !== UserTypeEnum.Normal;
  }

  private async loadFilterOptions(): Promise<void> {
    this.callTypeOptions = this.getCallTypeOptions();
    this.resultTypeOptions = this.getResultTypeOptions();
    this.contactTypeOptions = this.getContactTypeOptions();

    const tasks = [
      this.getAttendants().then((result) => {
        this.attendantOptions = result;
      }),
      this.getHistoryTypes().then((result) => {
        this.historyTypeOptions = result;
      }),
      this.getGroups().then((result) => {
        this.groupOptions = result;
      }),
    ];

    await Promise.all(tasks);
  }

  private getCallTypeOptions(): ISelectOption<CallCenterCallTypeEnum>[] {
    return [
      {
        code: CallCenterCallTypeEnum.Active,
        description: this.$t('crm.view.callReport.filter.ativa').toString(),
      },
      {
        code: CallCenterCallTypeEnum.Receptive,
        description: this.$t('crm.view.callReport.filter.receptiva').toString(),
      },
    ];
  }

  private getResultTypeOptions(): ISelectOption<CallCenterCallTypeEnum>[] {
    return [
      {
        code: CallCenterCallTypeEnum.Active,
        description: this.$t('crm.view.callReport.filter.result_ativa').toString(),
      },
      {
        code: CallCenterCallTypeEnum.NotSuccessful,
        description: this.$t('crm.view.callReport.filter.result_nao_sucedida').toString(),
      },
      {
        code: CallCenterCallTypeEnum.QuestionMistake,
        description: this.$t('crm.view.callReport.filter.result_engano_duvidas').toString(),
      },
    ];
  }

  private getContactTypeOptions(): ISelectOption<ConversationTypeEnum>[] {
    return [
      {
        code: ConversationTypeEnum.Client,
        description: this.$t('crm.view.callReport.filter.client').toString(),
      },
      {
        code: ConversationTypeEnum.Prospect,
        description: this.$t('crm.view.callReport.filter.prospect').toString(),
      },
      {
        code: ConversationTypeEnum.Undefined,
        description: this.$t('crm.view.callReport.filter.undefined').toString(),
      },
    ];
  }

  private async getAttendants(): Promise<UserModel[]> {
    return this.activityService.getAttendants();
  }

  private async getHistoryTypes(): Promise<HistoryTypeModel[]> {
    return sortBy(await this.activityService.getHistoryTypes(), 'nome');
  }

  private async getGroups(): Promise<GroupModel[]> {
    return sortBy(await this.activityService.getGroups(), 'descricao');
  }

  private getDateRanges(): IDateRangeConfig[] {
    return [
      {
        name: `${this.$t('global.today')}`,
        ...DateHelper.getTodayPeriod(),
      },
      {
        name: `${this.$t('global.yesterday')}`,
        ...DateHelper.getYesterdayPeriod(),
      },
      {
        name: `${this.$t('global.currentMonth')}`,
        ...DateHelper.getCurrentMonthPeriod(),
      },
      {
        name: `${this.$t('global.lastMonth')}`,
        ...DateHelper.getLastMonthsPeriod(1),
      },
      {
        name: `${this.$t('global.lastThreeMonths')}`,
        ...DateHelper.getLastMonthsPeriod(3),
      },
      {
        name: `${this.$t('global.lastSixMonths')}`,
        ...DateHelper.getLastMonthsPeriod(6),
      },
      {
        name: `${this.$t('global.lastYear')}`,
        ...DateHelper.getLastYearsPeriod(1),
      },
      {
        name: `${this.$t('global.currentYear')}`,
        ...DateHelper.getCurrentYearPeriod(),
      },
    ];
  }
}
